export const PlaceHolderContainer = ({
  children,
}: {
  children: React.ReactNode
}) => {
  return (
    <div className="w-full h-full bg-moment-white-200 dark:bg-moment-black-100 p-[12px] rounded-lg flex items-center justify-center text-secondary">
      {children}
    </div>
  )
}
